import { createFileRoute } from "@tanstack/react-router";

import { NotFoundScreen } from "@/modules/shared/screens/NotFoundScreen";

export const Route = createFileRoute("/not-found")({
  component: NotFoundScreen,
});
